import React from 'react'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import NumberFormat from 'react-number-format'
import { ContDetail } from './styled'
import { StdCard } from 'components'
import { itemColumns } from '../../Create/data'

const PRDetail = (props) => {
  const { prDetail } = props
  let items = prDetail.data.items

  const attributeForPrItems = (props) => {
    const prData = props.prDetail.data || {}
    const items = prData ? prData.items ? prData.items : [] : []
    return {
      accountAssignmentOptions: props.accountAssignmentOptions,
      assetOptions: props.assetOptions,
      budgetTypeOptions: props.budgetTypeOptions,
      costCenterOptions: props.costCenterOptions,
      currencyOptions: props.currencyOptions,
      glAccountOptions: props.glAccountOptions,
      items,
      unitOptions: props.unitOptions,
      materialGroupOptions: props.materialGroupOptions,
      orderOptions: props.orderOptions,
      plantOptions: props.plantOptions,
      profitCenterOptions: props.profitCenterOptions,
      purchasingGroupOptions: props.purchasingGroupOptions,
      purchasingOrgOptions: props.purchasingOrgOptions,
      storageLocationOptions: props.storageLocationOptions,
      wbsOptions: props.wbsOptions,
      withActions: false,
      fields: null,
      change: null,
      showPrItemModal: null,
      costCenterByRequester: null,
      menuSubCategory: null,
      editPrItem: null,
      onSubmitItem: null,
    }
  }

  return (
    <StdCard title='Item Detail' style={{ width: '100%' }}>
      <div style={{ marginTop: '1rem', flex: 1 }}>
        <ReactTable
          // className='prItem'
          className='prItem -striped -highlight'
          data={items}
          columns={itemColumns(attributeForPrItems(props))}
          defaultPageSize={10}
          minRows={items.length > 10 ? 10 : items.length || 5}
          showPagination={items.length > 10}
          previousText='previous'
          nextText='next'
        />
      </div>
      <ContDetail right={true}>
        <div>
          <div>Total Amount : </div>
          <div><NumberFormat decimalScale={2} fixedDecimalScale value={!prDetail.loading && (prDetail.data.totalAmount || "-")} displayType={'text'} thousandSeparator={true} /></div>
          <div>{!prDetail.loading && (prDetail.data.currency || '')}</div>
        </div>
        <div>
          <div>VAT {`${!prDetail.loading && prDetail.data.vatRate}%`} : </div>
          <div><NumberFormat decimalScale={2} fixedDecimalScale value={!prDetail.loading && (prDetail.data.vatAmount)} displayType={'text'} thousandSeparator={true} /></div>
          <div>{!prDetail.loading && (prDetail.data.currency || '')}</div>
        </div>
        <div>
          <div>Net Amount : </div>
          <div><NumberFormat decimalScale={2} fixedDecimalScale value={!prDetail.loading && (prDetail.data.totalAmountIncludeVat || "-")} displayType={'text'} thousandSeparator={true} /></div>
          <div>{!prDetail.loading && (prDetail.data.currency || '')}</div>
        </div>
      </ContDetail>
    </StdCard>
  )
}

const mapStateToProps = (state) => {
  let companyCode = state.pr.prDetail.data.companyName.split('|')[0]
  const orderOptions = state.options.orders.data.map(o => ({
    ...o,
    text: o.text.removeLeadingZero(),
  }))
  return {
    prDetail: state.pr.prDetail,
    budgetTypeOptions: state.options.budgetTypes.data,
    assetOptions: state.options.assets.data.filter(a => a.companyCode === companyCode),
    unitOptions: state.options.units.data,
    currencyOptions: state.options.currencies.data,
    accountAssignmentOptions: state.options.accountAssignments.data,
    materialGroupOptions: state.options.materialGroups.data,
    plantOptions: state.options.plants.data,
    storageLocationOptions: state.options.storageLocations.data,
    purchasingGroupOptions: state.options.purchasingGroups.data,
    glAccountOptions: state.options.glAccounts.data,
    costCenterOptions: state.options.costCenters.data,
    orderOptions,
    purchasingOrgOptions: state.options.purchasingOrgs.data,
    wbsOptions: state.options.wbsElements.data,
    profitCenterOptions: state.options.profitCenters.data,
    companyCode
  }
}

const mapDispatchToProps = { }

export default connect(mapStateToProps, mapDispatchToProps)(PRDetail)
